import { render, staticRenderFns } from "./PublicQuotationPages12.vue?vue&type=template&id=55d06fe1&scoped=true&"
import script from "./PublicQuotationPages12.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d06fe1",
  null
  
)

export default component.exports